import { makeRequest } from "@/helpers/apiWrapper";
import useCartStore from "@/Store/cartStore";
import { useAuthModalStore } from "@/Store/useAuthModalStore";
import { useUserStore } from "@/Store/UserInfoStore";
import useWishlistStore from "@/Store/wishlistStore";
import { Menu, MenuItem } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import {
  AlignRight,
  Bell,
  ChevronDown,
  Heart,
  LayoutDashboard,
  LogOut,
  Search,
  ShoppingBag,
  User,
  X
} from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import MobileHeaderDropdown from "../Layout/MobileHeaderDropdown";

const HeaderRight = ({
  storeId = undefined,
  setMobileHeaderView,
  mobileHeaderView,
}) => {
  const { clearUser, user } = useUserStore((state) => state);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { t } = useTranslation();
  const cartLength = useCartStore((state) => state.getTotalQuantity());
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const showLogin = query.get("showLogin");
  const token = localStorage.getItem("token");
  const wishlistCount = useWishlistStore((s) => s.wishlist.length);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(open ? null : event.currentTarget);
  };
  const { openAuthModal, openStatusModal } = useAuthModalStore();

  const { mutateAsync } = useMutation({
    mutationFn: () =>
      makeRequest({ endpoint: `/api/auth/delete-cache`, method: "DELETE" }),
  });

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    navigate("/");
    await mutateAsync();
    setAnchorEl(null);
    localStorage.removeItem("token");
    clearUser();
  };

  useEffect(() => {
    if (showLogin && !user?._id) {
      navigate("/login")
    }
  }, [showLogin, user]);

  return (
    <div className="w-auto flex items-center justify-center gap-3 relative">
      {!location.pathname.includes("/dashboard") && <div className="relative">
        <ShoppingBag
          size={25}
          onClick={() => navigate("/buy-product")}
          className="flex relative lg:w-10 lg:h-10 w-8 h-8 px-2 py-1 justify-center border rounded-full
                 items-center gap-2  !font-black bg-white text-[#000]  cursor-pointer"
        />
        {cartLength > 0 && (
          <span className="absolute top-0 -right-2 bg-blue-600 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center">
            <span>{cartLength}</span>
          </span>
        )}
      </div>}

      {token && user ? (
        <>
          {location.pathname.includes("/dashboard") ? (
            <>
              <Search
                size={18}
                className="flex lg:w-10 lg:h-10 w-8 h-8 px-2 py-1 justify-center border rounded-full
                 items-center gap-2  bg-white text-[#000] cursor-pointer"
              />
              <Bell
                size={18}
                className="flex lg:w-10 lg:h-10 w-8 h-8 px-2 py-1 justify-center border rounded-full
                 items-center gap-2  bg-white text-[#000] cursor-pointer"
              />
            </>
          ) : (
            <>
              <div className="relative">
                <Heart
                  onClick={() => navigate("/product-wishlist")}
                  size={18}
                  className="flex lg:w-10 lg:h-10 w-8 h-8 px-2 py-1 justify-center border rounded-full font-[600]
                items-center gap-2  bg-white text-[#000] cursor-pointer relative"
                />
                {wishlistCount > 0 && (
                  <span className="absolute top-0 -right-2 bg-blue-600 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center">
                    <span>{wishlistCount}</span>
                  </span>
                )}
              </div>

              {mobileHeaderView ? (
                <X
                  onClick={() => setMobileHeaderView(false)}
                  size={18}
                  className="lg:hidden  flex lg:w-10 lg:h-10 w-8 h-8 px-2 py-1 justify-center border rounded-full
                 items-center gap-2  bg-white text-[#000] cursor-pointer"
                />
              ) : (
                <AlignRight
                  onClick={() => setMobileHeaderView(true)}
                  size={18}
                  className="lg:hidden  flex lg:w-10 lg:h-10 w-8 h-8 px-2 py-1 justify-center border rounded-full
                 items-center gap-2  bg-white text-[#000] cursor-pointer"
                />
              )}
            </>
          )}
          {mobileHeaderView && (
            <MobileHeaderDropdown
              user={user}
              handleClick={handleClick}
              handleLogout={handleLogout}
              handleClose={handleClose}
              anchorEl={anchorEl}
              open={open}
            />
          )}
          <div
            className="bg-white rounded-[100px] cursor-pointer
           border border-[#E4E3E5] overflow-hidden 
           hidden lg:flex gap-2 items-center py-1 pr-[14px] pl-[6px]"
            onClick={handleClick}
          >
            <div className="flex items-center justify-center gap-2 ">
              <div className=" ">
                {user.profileImage?.url && (
                  <img
                    src={user.profileImage.url}
                    alt="avatar"
                    className="w-[30px] h-[30px] rounded-full object-cover"
                  />
                )}
                {!user.profileImage?.url && (
                  <div className="w-[30px] h-[30px] flex items-center justify-center font-bold text-xl text-white rounded-full bg-[#248358]">
                    {user?.first_name?.[0] || user?.company_name?.[0]}
                  </div>
                )}
              </div>
              <div className="flex flex-col ">
                <h4 className="font-[600] p-0 m-0 leading-[14px] hidden lg:block">
                  {user?.first_name || user.company_name} {user.last_name || ""}
                </h4>
              </div>
            </div>
            <div className="cursor-pointer">
              <ChevronDown
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              />

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{ mt: "10px", ml: "80px" }}
              >
                <MenuItem className="flex gap-2" onClick={handleLogout}>
                  {" "}
                  <LogOut size={20} /> {t("LogOut")}
                </MenuItem>
                <MenuItem
                  className="flex gap-2"
                  onClick={() =>
                    navigate(
                      user.source !== "ecom"
                        ? "/dashboard/seller"
                        : "/dashboard/buyer",
                    )
                  }
                >
                  {" "}
                  <LayoutDashboard size={20} /> {t("Dashboard")}
                </MenuItem>
              </Menu>
            </div>
          </div>
        </>
      ) : (
        <div className="relative flex items-center gap-2">
          <div className="hidden lg:flex gap-4">
            <button
              onClick={() => navigate("/login")}
              className=" px-2 p-1 border font-bold cursor-pointer"
            >
              {t("Login")}
            </button>
            <button
              onClick={() => navigate("/signup")}
              className=" px-2 p-1 border font-bold cursor-pointer"
            >
              {t("Sign Up")}
            </button>
          </div>

          <div className="lg:hidden">
            <div
              onClick={(e) => setAnchorEl(e.currentTarget)}
              className="flex lg:w-10 lg:h-10 w-8 h-8 px-2 justify-center items-center border rounded-full bg-white cursor-pointer"
            >
              <User size={20} />
            </div>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={() => navigate("/login")}>{t("Login")}</MenuItem>
              <MenuItem onClick={() => navigate("/signup")}>{t("Sign Up")}</MenuItem>
            </Menu>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderRight;
